import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from '../layout/Layout';
import gateStyles from './AgentWidgetGate.module.css';

interface AgentWidgetGateSessionConflictProps {
  onForceLogout: () => void;
  onCancel: () => void;
}

export function AgentWidgetGateSessionConflict({
  onForceLogout,
  onCancel,
}: AgentWidgetGateSessionConflictProps) {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className={gateStyles.errorContent}>
        <div className={gateStyles.warningIcon}>
          <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor" aria-hidden="true">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
        </div>
        <h3 className={gateStyles.errorTitle}>{t('agent:session.conflictTitle')}</h3>
        <p className={gateStyles.errorMessage}>{t('agent:session.conflictMessage')}</p>
        <p className={gateStyles.errorHint}>{t('agent:session.conflictHint')}</p>
        <div className={gateStyles.buttonGroup}>
          <button type="button" className={gateStyles.forceLogoutButton} onClick={onForceLogout}>
            {t('agent:session.forceLogout')}
          </button>
          <button type="button" className={gateStyles.cancelButton} onClick={onCancel}>
            {t('common:buttons.cancel')}
          </button>
        </div>
      </div>
    </Layout>
  );
}
